export default "https://c.travel-assets.com/partner-portal/angle_edge_mobile.3cbecb34b2d2.svg";